import React from 'react';
import { Globe } from 'lucide-react';
import './Settings.css';

const groupIconProps = { size: 18, strokeWidth: 1.75 };

const Settings = () => {
    return (
        <div className="settings">
            <main className="settings-content">

                <section className="settings-section">
                    <div className="settings-section-header">
                        <div>
                            <h2 className="settings-section-title">Account Preferences</h2>
                            <p className="settings-section-subtitle">Manage your account settings and preferences</p>
                        </div>
                    </div>

                    <div className="settings-group">
                        <h3 className="group-title">
                            <Globe {...groupIconProps} className="group-title-icon" aria-hidden />
                            Language & Region
                        </h3>
                        <div className="setting-item">
                            <div className="setting-info">
                                <div className="setting-label">Language</div>
                                <div className="setting-description">Choose your preferred language</div>
                            </div>
                            <div className="select-dropdown">
                                <select>
                                    <option value="en">English</option>
                                    <option value="es">Español</option>
                                    <option value="fr">Français</option>
                                    <option value="de">Deutsch</option>
                                </select>
                            </div>
                        </div>
                        <div className="setting-item">
                            <div className="setting-info">
                                <div className="setting-label">Currency</div>
                                <div className="setting-description">Select your preferred currency</div>
                            </div>
                            <div className="select-dropdown">
                                <select>
                                    <option value="usd">USD ($)</option>
                                    <option value="eur">EUR (€)</option>
                                    <option value="gbp">GBP (£)</option>
                                    <option value="inr">INR (₹)</option>
                                </select>
                            </div>
                        </div>
                        <div className="setting-item">
                            <div className="setting-info">
                                <div className="setting-label">Time Zone</div>
                                <div className="setting-description">Your current time zone</div>
                            </div>
                            <div className="select-dropdown">
                                <select>
                                    <option value="est">Eastern Time (EST)</option>
                                    <option value="pst">Pacific Time (PST)</option>
                                    <option value="utc">UTC</option>
                                    <option value="ist">Indian Standard Time (IST)</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="action-buttons">
                        <button className="btn-primary">Save All Settings</button>
                        {/* <button className="btn-secondary">Reset to Default</button> */}
                    </div>
                </section>
            </main>
        </div>
    );
};

export default Settings;
